import {css, view, Action} from '@sail/ui/deprecated';

import {useTheme} from '@stripe-internal/conversations-ui';
import {useMemo} from 'react';
import {IconAsset} from '@sail/icons/types';
import {ChannelIcon} from './ChannelIcon';

type Props = {
  title: React.ReactNode;
  icon: IconAsset;
  disabled: boolean;
  description?: React.ReactNode;
  dataTestId: string;
  onClick: () => void;
  isLast?: boolean;
};

export const OptionButton = ({
  title,
  icon,
  disabled,
  description,
  dataTestId,
  onClick,
  isLast = false,
}: Props): JSX.Element => {
  const theme = useTheme();
  const focusStyles = useMemo(() => {
    const buttonStyle = {
      borderColor: css.value(theme.ctaColor),
      color: css.value(theme.ctaColor),
      focusRing: css.value('none'),
    };

    const iconStyle = {
      backgroundColor: css.value('$color.brand50'),
    };

    return {
      '&:focus': buttonStyle,
      '&:hover': buttonStyle,
      '&:focus .channel-icon': iconStyle,
      '&:hover .channel-icon': iconStyle,
    };
  }, [theme]);

  return (
    <Action
      disabled={disabled}
      data-testid={dataTestId}
      onPress={onClick}
      css={{
        background: 'surface',
        stack: 'x',
        alignItems: css.value('center'),
        padding: css.value('$space.small $space.150'),
        marginBottom: isLast ? 0 : 'small',
        border: css.value('2px solid $color.neutral150'),
        borderRadius: 'medium',
        opacity: disabled ? css.value('0.5') : css.value('1'),
        cursor: disabled ? css.value('default') : css.value('pointer'),
        ...(!disabled && focusStyles),
      }}
    >
      <ChannelIcon icon={icon} />
      <view.div css={{marginLeft: 'small'}}>
        <view.h3
          css={{
            marginTop: 0,
            marginBottom: 0,
            font: 'bodyEmphasized',
          }}
        >
          {title}
        </view.h3>
        <view.div css={{font: 'caption', color: 'secondary'}}>
          {description}
        </view.div>
      </view.div>
    </Action>
  );
};
